module.exports = __webpack_public_path__ + "static/media/scottkevin88.3cabf255.png";